import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';
import { ButtonWithIcon } from '@els/els-react--button';

function DocumentIndexTerms({ keywords, closeClick }) {
  return (
    <div className="result-detail-panel u-els-margin-top-1o2">
      <div className="result-detail-panel-wrapper">
        <h4 className="u-els-margin-bottom-1o2">Index Terms</h4>
        <div className="result-detail-panel u-els-font-size-base u-els-line-height-default">
          <div className="result-detail-block">
            {keywords.map((keyword) => (
              <div key={keyword.type}>
                <b>{keyword.type}: </b>
                {keyword.value &&
                  // eslint-disable-next-line custom/no-unsafe-deep-access
                  keyword.value.map((value) => (
                    <React.Fragment key={value}>
                      <InnerHTML tag="span" html={value} />
                      {/* eslint-disable-next-line custom/no-unsafe-deep-access */}
                      {keyword.value.indexOf(value) !== keyword.value.length - 1 && <span className="separator" />}
                    </React.Fragment>
                  ))}
              </div>
            ))}
          </div>
        </div>
        <ButtonWithIcon
          type="link"
          sprite="Close"
          linkIconSize="xs"
          className="els-btn-modal-close e2e-close"
          onClick={(e) => {
            e.preventDefault();
            closeClick();
          }}
          iconOnly>
          Close index terms
        </ButtonWithIcon>
      </div>
    </div>
  );
}

DocumentIndexTerms.propTypes = {
  keywords: PropTypes.array.isRequired,
  closeClick: PropTypes.func.isRequired,
};

export default DocumentIndexTerms;
